// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nw-0";